import { Component, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { IpoTranslatePipe } from '@ip-only/front-end-library';
import { finalize } from 'rxjs';
import { ToastsService } from '../../shared/toast/toast.service';
import { isTopLevelDomainFI } from '../../shared/util/deploy-helper';
import { CONSTRUCTION_RESPONSIBLE } from '../../user-roles-def/user-roles';
import { ResourcesService } from '../../user/resources.service';
import { UserService } from '../../user/user.service';
import { DeliveryOverviewService } from '../service/delivery-overview.service';
import { DeliveryOverviewResourcesService } from '../service/resources.service';

export enum DeliveryOverviewTabs {
  All,
  Starred,
}

@Component({
  selector: 'app-delivery-overview-wrapper',
  templateUrl: './delivery-overview-wrapper.component.html',
  styleUrls: ['./delivery-overview-wrapper.component.scss'],
  standalone: false,
})
export class DeliveryOverviewWrapperComponent {
  initialProjects$ = this.deliveryOverviewService.getInitialProjects();
  projects$ = this.deliveryOverviewService.getProjects$();
  starredProjects$ = this.deliveryOverviewService.getStarredProjects$();
  loadingState$ = this.resourcesService.getEntitiesLoadingState$();

  deliveryOverviewTabs = DeliveryOverviewTabs;

  tab =
    this.deliveryOverviewService.localStorageStarredProjects &&
    this.deliveryOverviewService.localStorageStarredProjects.length > 0
      ? DeliveryOverviewTabs.Starred
      : DeliveryOverviewTabs.All;

  isDeliveryPortalFI: boolean = isTopLevelDomainFI();

  hasNoProjectMatches = this.deliveryOverviewService.hasNoProjectMatches;

  isCreatingIfs = signal(false);

  get canCreateIfs(): boolean {
    const user = this.userService.getPortalUserOnce();
    return (
      Boolean(user?.federatedUser) &&
      this.userService.checkAccess([CONSTRUCTION_RESPONSIBLE])
    );
  }

  constructor(
    private deliveryOverviewService: DeliveryOverviewService,
    private deliveryOverviewResourcesService: DeliveryOverviewResourcesService,
    private resourcesService: ResourcesService,
    private toastsService: ToastsService,
    private titleService: Title,
    private translate: IpoTranslatePipe,
    private userService: UserService,
  ) {
    this.titleService.setTitle(
      this.translate.transform(this.isDeliveryPortalFI ? 'tabFI' : 'tabSE'),
    );
  }

  onActiveTabChanged(tab: DeliveryOverviewTabs) {
    this.tab = tab;
  }

  createIfs() {
    if (!this.canCreateIfs) {
      return;
    }

    const ifs = this.deliveryOverviewService.filterString().trim();

    if (!ifs || this.isCreatingIfs()) {
      return;
    }

    this.isCreatingIfs.set(true);

    this.deliveryOverviewResourcesService
      .createIfs$(ifs)
      .pipe(
        finalize(() => {
          this.isCreatingIfs.set(false);
        }),
      )
      .subscribe({
        next: () => {
          this.toastsService.addToast(
            {
              type: 'success',
              message: 'IFS created successfully',
            },
            6000,
          );
          this.resourcesService.refreshResources(ifs);
        },
        error: (error) => {
          console.error('Could not create IFS resource', error);

          this.toastsService.addToast(
            {
              type: 'error',
              message: 'Could not create IFS',
            },
            6000,
          );
        },
      });
  }
}
